import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["partners"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Divider } from '@snack-uikit/divider';
import { TruncateString } from '@snack-uikit/truncate-string';
import { Typography } from '@snack-uikit/typography';
import { PRICE_PERIOD } from '../../../types';
import { formatNumber, getPrice, parseKeyToDataTest } from '../../../utils';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PRICE_NAME = _defineProperty(_defineProperty(_defineProperty({}, PRICE_PERIOD.Month, 'В месяц'), PRICE_PERIOD.Day, 'В день'), PRICE_PERIOD.Hour, 'В час');
export function BasePriceCount(_ref) {
  var price = _ref.price,
    pricePeriod = _ref.pricePeriod,
    freeTier = _ref.freeTier,
    mobile = _ref.mobile;
  var total = getPrice({
    price: price,
    pricePeriod: pricePeriod
  });
  var dataTestAttribute = parseKeyToDataTest('product', 'price');
  if (freeTier && !total) return /*#__PURE__*/_jsxs("div", {
    className: styles.price,
    "data-mobile": mobile || undefined,
    children: ["\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E", /*#__PURE__*/_jsx("br", {}), "\u043D\u0430\u0432\u0441\u0435\u0433\u0434\u0430"]
  });
  return /*#__PURE__*/_jsxs("div", {
    className: styles.price,
    "data-mobile": mobile || undefined,
    "data-test-id": dataTestAttribute,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.total,
      children: [/*#__PURE__*/_jsx(Typography.SansTitleM, {
        children: /*#__PURE__*/_jsx(TruncateString, {
          text: formatNumber(total),
          maxLines: 1
        })
      }), /*#__PURE__*/_jsx(Typography.SansBodyL, {
        children: "\u20BD"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles.caption,
      children: "".concat(PRICE_NAME[pricePeriod], " c \u041D\u0414\u0421")
    })]
  });
}
export function PartnersPriceCount(_ref2) {
  var price = _ref2.price,
    pricePeriod = _ref2.pricePeriod,
    mobile = _ref2.mobile,
    hasCounter = _ref2.hasCounter;
  var total = getPrice({
    price: price,
    pricePeriod: pricePeriod
  });
  var partnersTotal = getPrice({
    price: price,
    pricePeriod: pricePeriod,
    partners: true
  });
  var mobileWithCounter = mobile && hasCounter;
  var dataTestAttribute = parseKeyToDataTest('product', 'price-partners');
  var partnersSale = "-".concat(100 - Math.trunc(partnersTotal / total * 100 + 0.1), "%");
  return /*#__PURE__*/_jsxs("div", {
    className: styles.partnersWrapper,
    "data-mobile-with-counter": mobileWithCounter || undefined,
    "data-test-id": dataTestAttribute,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.price,
      "data-mobile": mobile || undefined,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.caption,
        children: "\u0420\u044B\u043D\u043E\u0447\u043D\u0430\u044F \u0446\u0435\u043D\u0430"
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.total,
        children: [/*#__PURE__*/_jsx(Typography.SansTitleM, {
          children: /*#__PURE__*/_jsx(TruncateString, {
            text: formatNumber(total),
            maxLines: 1
          })
        }), /*#__PURE__*/_jsx(Typography.SansBodyL, {
          children: "\u20BD"
        })]
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      orientation: mobileWithCounter ? 'horizontal' : 'vertical',
      className: styles.divider
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.price,
      "data-mobile": mobile || undefined,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.caption,
        children: ["\u041F\u0430\u0440\u0442\u043D\u0435\u0440\u0441\u043A\u0430\u044F \u0446\u0435\u043D\u0430 ", total > 0 && /*#__PURE__*/_jsx("span", {
          className: styles.sale,
          children: partnersSale
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.total,
        children: [/*#__PURE__*/_jsx(Typography.SansTitleM, {
          children: /*#__PURE__*/_jsx(TruncateString, {
            text: formatNumber(partnersTotal),
            maxLines: 1
          })
        }), /*#__PURE__*/_jsx(Typography.SansBodyL, {
          children: "\u20BD"
        })]
      })]
    })]
  });
}
export function PriceCount(_ref3) {
  var partners = _ref3.partners,
    props = _objectWithoutProperties(_ref3, _excluded);
  return partners ? /*#__PURE__*/_jsx(PartnersPriceCount, _objectSpread({}, props)) : /*#__PURE__*/_jsx(BasePriceCount, _objectSpread({}, props));
}